// extracted by mini-css-extract-plugin
export default {"base":"ActionHiddenMod_base__0q-pD","isDisabled":"ActionHiddenMod_isDisabled__+-94+"};